import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';
import lazyLoad from './script/lazyLoad';
import sliders from './script/slider';
import mobMenu from './script/mobMenu';
import dropdown from './script/dropdowns';
import readMore from './script/readmore';
import accordian from './script/accordian';
import headerPopups from './script/headerPopups';
import lineMove from './script/lineMove';
import tabs from './script/tabs';
import showHide from './script/showHide';
import './script/popupCalls';
import stickyHeader from './script/stickyHeader';
import megamenu from './script/megamenu';
// import blogSliders from './script/blog';
// import showHideFilters from './script/showHideFilters';
// import cartValidation from './script/cartValidation';

addEvent();
appHeight();
lazyLoad.init();
sliders.init();
mobMenu.init();
dropdown.init();
readMore.init();
accordian.init();
headerPopups.init();
lineMove.init();
tabs.init();
showHide.init();
stickyHeader.init();
megamenu.init();
// blogSliders.init();
// showHideFilters.init();
// cartValidation.init();
